import { useMutation } from 'react-query';
import { axios } from '@/lib/axios';
import { MutationConfig } from '@/lib/react-query';

export type ConversationTokenDTO = {
  agent_id: string;
};

export type ConversationTokenResponse = {
  token: string;
};

export const getConversationToken = ({
  agent_id,
}: ConversationTokenDTO): Promise<ConversationTokenResponse> => {
  return axios.get('/chatbot/conversation/token', {
    params: { agent_id },
  });
};

type UseConversationTokenOptions = {
  config?: MutationConfig<typeof getConversationToken>;
};

export const useGetConversationToken = ({ config }: UseConversationTokenOptions = {}) => {
  return useMutation({
    ...config,
    mutationFn: getConversationToken,
  });
};
